module.exports = __webpack_public_path__ + "img/kate-moross-website.a87a9a6d.jpeg";